// import isArrayBuffer from 'is-array-buffer'; // is-array-buffer
// import ab2str from 'arraybuffer-to-string'; // arraybuffer-to-string
// import OKMException from './okmException';
import * as blobUtil from 'blob-util';
import format from 'string-format';
import store from './store';
import axios from 'axios';

export default {
  login(user, password) {
    console.log("login:", store.getters.getUrl, user, password);
    const url = store.getters.getUrl + "/rest/auth/login";
    const params = {
      "username": user,
      "password": password
    };

    console.log(url, params);
    return axios.post(url, params);
  },

  getNodePath(nodeUuid) {
    console.log("getNodePath:", store.getters.getUrl, nodeUuid);
    const url = store.getters.getUrl + format("/rest/repository/nodes/{nodeUuid}/path", {nodeUuid});
    const headers = {
      'headers': {
        'Authorization': store.getters.getToken
      }
    };

    return axios.get(url, headers);
  },

  getNodeUuid(nodePath) {
    console.log("getNodeUuid:", store.getters.getUrl, nodePath);
    const url = store.getters.getUrl + format("/rest/repository/nodes/uuid?nodePath={nodePath}", {nodePath});
    const headers = {
      'headers': {
        'Authorization': store.getters.getToken
      }
    };

    return axios.get(url, headers);
  },

  getDocuments(fldUuid) {
    console.log("getDocuments:", store.getters.getUrl, fldUuid);
    const url = store.getters.getUrl + format("/rest/documents/{fldUuid}/children", {fldUuid});
    const headers = {
      'headers': {
        'Authorization': store.getters.getToken
      }
    };

    return axios.get(url, headers);
  },

  getDownloadToken(docUuid) {
    console.log("getDownloadToken:", store.getters.getUrl, docUuid);
    const url = store.getters.getUrl + format("/rest/nodes/{docUuid}/downloadToken?preview=true", {docUuid});
    const headers = {
      'headers': {
        'Authorization': store.getters.getToken
      }
    };

    return axios.post(url, null, headers);
  },

  getConfiguration(key) {
    console.log("getConfiguration:", store.getters.getUrl, key);
    const url = store.getters.getUrl + format("/rest/repository/configuration?key={key}", {key});
    const headers = {
      'headers': {
        'Authorization': store.getters.getToken
      }
    };

    return axios.get(url, headers);
  },

  stampDocument(docUuid, stampId, image, ratio) {
    console.log("stampDocument:", store.getters.getUrl, docUuid, stampId, ratio);
    const url = store.getters.getUrl + format("/rest/stamp/nodes/{docUuid}/stamp/image/{stampId}/custom", {docUuid, stampId});
    const headers = {
      'headers': {
        'Authorization': store.getters.getToken
      },
      'Content-type': 'multipart/form-data'
    };

    let params = new FormData();
    params.append('exprX', '');
    params.append('exprY', '');
    params.append('range', '1');
    params.append('ratio', ratio);
    params.append('image', blobUtil.dataURLToBlob(image));

    return axios.post(url, params, headers);
  },

  createDocument(fldUuid, name, blob) {
    console.log("createDocument:", store.getters.getUrl, fldUuid, name, blob);
    const url = store.getters.getUrl + format("/rest/documents/parents/{fldUuid}", {fldUuid});
    let headers = {
      'headers': {
        'Authorization': store.getters.getToken
      },
      'Content-type': 'multipart/form-data'
    };

    let params = new FormData();
    params.append('content', blob, name);
    params.append('autoUpdate', true);

    return axios.post(url, params, headers);
  },

  addGroup(docUuid, grpName, properties) {
    console.log("addGroup:", store.getters.getUrl, docUuid, grpName, properties);
    const url = store.getters.getUrl + format("/rest/propertyGroups/nodes/{docUuid}/groups", {docUuid});
    const headers = {
      'headers': {
        'Authorization': store.getters.getToken
      }
    };

    let params = {
      grpName: grpName,
      properties: properties
    };

    return axios.post(url, params, headers);
  },

  hasGroup(docUuid, grpName) {
    console.log("hasGroup:", store.getters.getUrl, docUuid, grpName);
    const url = store.getters.getUrl +  format("/rest/propertyGroups/nodes/{docUuid}/groups/{grpName}/valid", {docUuid, grpName});
    const headers = {
      'headers': {
        'Authorization': store.getters.getToken
      }
    };

    return axios.get(url, headers);
  },

  getClusterId() {
    console.log("getClusterId:", store.getters.getUrl);
    const url = store.getters.getUrl + "/rest/repository/configuration/clusterUuid";
    const headers = {
      'headers': {
        'Authorization': store.getters.getToken
      }
    };

    return axios.get(url, headers);
  }
}
